import { render } from "./drag_placeholder.vue?vue&type=template&id=c020c07e"
import script from "./drag_placeholder.vue?vue&type=script&lang=js"
export * from "./drag_placeholder.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/docuseal-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__